import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LauftextComponent } from './lauftext.component';
import { AngularMaterialModule } from '../../material.module';
import { DirectiveModule } from '@app/directives/directive.module';

@NgModule({
    declarations: [LauftextComponent],
    imports: [
        CommonModule,
        AngularMaterialModule,
        DirectiveModule,
    ],
    exports: [
        LauftextComponent
    ]
})
export class LauftextModule { }
